'use strict';

/**
 * @ngdoc service
 * @name mx.SolutionBuilderAgent.HelpService
 * @module mx.SolutionBuilderAgent
 *
 * @description
 * Provides list of methods for working with help Rest Services.
 */
HelpService.$inject = ['$q', 'mx.SolutionBuilderAgent.Http'];
export default function HelpService($q, http) {
	var cache = { DataDefinition: {}, Entity: {}, DataQuery: {}, Service: {}, ServiceOperation: {}, Workflow: {} };

	return {
		getServiceInfo: getServiceInfo,
		getOperationInfo: getOperationInfo,
		getWorkflowInfo: getWorkflowInfo,
		getDqInfo: getDqInfo,
		getCiInfo: getCiInfo,
		getDdInfo: getDdInfo,
	};

	function getWorkflowInfo(id, skipError) {
		return getEntityInfo(id, 'Workflow', 'api/Workflow/Descriptor', skipError);
	}

	function getServiceInfo(id, skipError) {
		return getEntityInfo(id, 'Service', undefined, skipError);
	}

	function getOperationInfo(id, skipError) {
		return getEntityInfo(id, 'ServiceOperation', undefined, skipError);
	}

	function getDqInfo(id, skipError) {
		return getEntityInfo(id, 'DataQuery', undefined, skipError);
	}

	function getDdInfo(entityName, skipError) {
		return getEntityInfo(entityName, 'DataDefinition', undefined, skipError);
	}

	function getCiInfo(entityName, skipError) {
		return getEntityInfo(entityName, 'Entity', undefined, skipError);
	}

	function getEntityInfo(id, entityType, serviceUrl, skipError = false) {
		const cached = cache[entityType][id];
		if (cached) {
			return $q.when(angular.copy(cached));
		}
		const url = serviceUrl || 'api/Help/' + entityType;
		return http.get(url + '/' + id, {}, {}, skipError).then(
			function (info) {
				cache[entityType][id] = info;
				return angular.copy(info);
			},
			function (error) {
				return skipError ? undefined : $q.reject(error);
			}
		);
	}
}
